export default "__VITE_PUBLIC_ASSET__7f733632__"